import { create } from "zustand";
import { VocApprovalStoreProps } from "./interface/voc-approval.interface";
import { approveMultipleSource, getAvailableApprovalMonths, getCompanyGroupPermission } from "src/services/voc-approval";
import { ApproveMultipleSourcePayload } from "src/entity/voc-approve/voc-approve.entity";

export const vocApprovalStore = create<VocApprovalStoreProps>((set) => ({
  companyGroupPermission: [],
  approvalOptionMonthly: [],
  loadingApprovalOption: false,
  loadingApproveAction: false,
  error: null,
  getAvailableApprovalMonthsStore: async (query: string) => {
    set(() => ({ loadingApprovalOption: true }));
    try {
      const res = await getAvailableApprovalMonths(query);
      set(() => ({ loadingApprovalOption: false, approvalOptionMonthly: res.data?.data || null }));
    } catch (err: any) {
      set(() => ({ loadingApprovalOption: false, error: err?.message, approvalOptionMonthly: null }));
    }
  },
  approveMultipleSourceStore: async (data: ApproveMultipleSourcePayload) => {
    set(() => ({ loadingApproveAction: true }));
    try {
      const res = await approveMultipleSource(data);
      set(() => ({ loadingApproveAction: false }));

      console.log("Approve Multiple Source Response: ", res.data);
    } catch (err: any) {
      console.error(err);
      set(() => ({ loadingApproveAction: false }));

      throw err;
    }
  },
  getCompanyGroupPermission: async (query: string) => {
    try {
      const res = await getCompanyGroupPermission(query);
      set(() => ({ companyGroupPermission: res.data?.data?.permission || null }));
    } catch (err: any) {
      console.error(err);

      throw err;
    }
  },
}));
